import Input from 'components/Form/Input'
import SearchIcon from 'components/icons/SearchIcon'
import React, { useEffect } from 'react'
import styled from 'styled-components'

const StyleInput = styled(Input)`
  background: ${props => props.background ?? ''};
  .ant-input {
    font-weight: 400;
    font-size: 16px;
    line-height: 24;
    margin-left: 10px;
    background: ${props => props.background ?? ''};
  }
  border: ${props => props?.borderLess && 'none'};
  border-radius: ${props => props?.borderRadius};
  box-shadow: ${props => props?.boxShadow};
`

const SearchInput = ({
  searchValue,
  setSearchValue,
  height = '38px',
  width = '240px',
  placeholder = 'Search',
  allowClear,
  suffix = <SearchIcon />,
  prefix = <SearchIcon />,
  bordered = true,
  iconPosition = 'prefix',
  background = 'none',
  setFlag,
  flag,
  handleSearch,
  boxShadow,
  borderRadius,
  ...rest
}) => {
  const onSearchChange = e => {
    setSearchValue(e.target.value)
  }

  if (setFlag) {
    setFlag(false)
  }

  useEffect(() => {
    if (flag) {
      setSearchValue('')
    }
  }, [flag])

  return (
    <StyleInput
      {...rest}
      width={width}
      height={height}
      background={background}
      placeholder={placeholder}
      suffix={iconPosition == 'suffix' && suffix}
      prefix={iconPosition == 'prefix' && prefix}
      value={searchValue}
      onChange={handleSearch ?? onSearchChange}
      allowClear={allowClear}
      bordered={bordered}
      boxShadow={boxShadow}
      borderRadius={borderRadius}
    />
  )
}
export default SearchInput
